import Modal from "../../modals/Modal";
import OpportunityAddItemsForm from "../opportunity/OpportunityAddItemsForm";
import { useEffect, useState } from "react";
import number_format from "../../../utils/number_format";
import OpportunityItemsModal from "../../modals/opportunity/OpportunityItemsModal";
import { Accordion } from "react-bootstrap";
import { useTranslation } from "../../../hooks/useTranslation";

export default function ProductConfigurationForm({
  handleClose,
  product,
  onSelect,
}) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [selectedConfiguration, setSelectedConfiguration] = useState({});
  const [configuratedItem, setConfiguratedItem] = useState([]);
  const [canOrder, setCanOrder] = useState(false);

  const createConfiguration = (event) => {
    event.preventDefault();
    setError(null);
  };

  useEffect(() => {
    let configuratedItemUpdated = [
      {
        product_id: product.product_id,
        quantity: 1,
        name: product.name,
        sku: product.sku,
      },
    ];
    if (product.configurations?.length > 0) {
      let canOrderUpdated = true;
      product.configurations.map((configuration, index) => {
        if (
          configuration.required_item === true &&
          !(
            index in selectedConfiguration ||
            (product.template_combinations === false &&
              Object.keys(selectedConfiguration).length > 0)
          )
        ) {
          canOrderUpdated = false;
        }
        if (index in selectedConfiguration) {
          configuration.products.map((product, pindex) => {
            if (selectedConfiguration[index] == product.product_id) {
              configuratedItemUpdated.push({
                product_id: product.product_id,
                quantity: 1,
                name: product.product.name,
                sku: product.product.sku,
              });
            }
          });
        }
      });

      setConfiguratedItem(configuratedItemUpdated);
      setCanOrder(canOrderUpdated);
    } else {
      setConfiguratedItem(configuratedItemUpdated);
      setCanOrder(true);
    }
  }, [selectedConfiguration]);

  let calculatedPrice = product.eu_price * ((100 - product.discount) / 100);
  if (product.configurations?.length > 0) {
    product.configurations.map((configuration, index) => {
      if (index in selectedConfiguration) {
        configuration.products.map((product, pindex) => {
          if (selectedConfiguration[index] == product.product_id) {
            calculatedPrice +=
              product.product.eu_price *
              ((100 - product.product.discount) / 100);
          }
        });
      }
    });
  }
  let calculatedPriceEU = product.eu_price;
  if (product.configurations?.length > 0) {
    product.configurations.map((configuration, index) => {
      if (index in selectedConfiguration) {
        configuration.products.map((product, pindex) => {
          if (selectedConfiguration[index] == product.product_id) {
            calculatedPriceEU += product.product.eu_price;
          }
        });
      }
    });
  }

  return (
    <form onSubmit={(e) => createConfiguration(e)}>
      <h2>
        {product.product_type} {product.name}{" "}
        {product.template_combinations || (
          <span className="badge badge-danger ms-3">
            {t("products.cannotCombineAddons")}
          </span>
        )}
      </h2>

      <Accordion defaultActiveKey={0}>
        {product.configurations?.length > 0 &&
          product.configurations.map((configuration, index) => (
            <Accordion.Item eventKey={index} key={index}>
              <Accordion.Header>
                {configuration.name}
                {configuration.required_item ? (
                  !(
                    product.template_combinations === false &&
                    Object.keys(selectedConfiguration).length > 0
                  ) && (
                    <span className="badge badge-success ms-3">
                      {t("products.requiredItem")}
                    </span>
                  )
                ) : (
                  <span className="badge badge-warning ms-3">
                    {t("products.optionalItem")}
                  </span>
                )}
              </Accordion.Header>
              <Accordion.Body>
                {configuration.products?.length > 0 && (
                  <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
                    {configuration.required_item !== true && (
                      <div className="menu-item">
                        <div
                          onClick={() =>
                            setSelectedConfiguration({
                              ...selectedConfiguration,
                              [index]: null,
                            })
                          }
                          className={
                            "cursor-pointer menu-link " +
                            (!(index in selectedConfiguration) ||
                            selectedConfiguration[index] == null
                              ? "active"
                              : "")
                          }
                        >
                          {!(index in selectedConfiguration) ||
                            (selectedConfiguration[index] == null && (
                              <span
                                className="menu-icon"
                                data-kt-element="icon"
                              >
                                <i className="ki-duotone ki-check fs-2">
                                  <span className="path1"></span>
                                  <span className="path2"></span>
                                </i>
                              </span>
                            ))}

                          <div className="menu-title d-flex justify-content-between">
                            <div style={{ color: "black" }}>
                              {t("products.dontNeed", { name: configuration.name })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {configuration.products.map((product2, pindex) => (
                      <div className="menu-item" key={pindex}>
                        <div
                          onClick={() =>
                            setSelectedConfiguration(
                              product.template_combinations
                                ? {
                                    ...selectedConfiguration,
                                    [index]: product2.product_id,
                                  }
                                : { [index]: product2.product_id }
                            )
                          }
                          className={
                            "cursor-pointer menu-link " +
                            (index in selectedConfiguration &&
                            selectedConfiguration[index] == product2.product_id
                              ? "active"
                              : "")
                          }
                        >
                          {index in selectedConfiguration &&
                            selectedConfiguration[index] ==
                              product2.product_id && (
                              <span
                                className="menu-icon"
                                data-kt-element="icon"
                              >
                                <i className="ki-duotone ki-check fs-2">
                                  <span className="path1"></span>
                                  <span className="path2"></span>
                                </i>
                              </span>
                            )}

                          <div className="menu-title d-flex justify-content-between">
                            <div style={{ color: "black" }}>
                              {product2.product.name}
                            </div>
                            <div style={{ color: "black" }}>
                              +
                              {number_format(
                                product2.product.eu_price *
                                  ((100 - product2.product.discount) / 100),
                                2,
                                ",",
                                "."
                              )}
                              &nbsp;
                              {product2.product.currency}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
      </Accordion>

      <div className="row my-5">
        <div className="col-6 border-end">
          <div>
            <small>{t("products.yourPrice")}</small>
          </div>
          <div className="fs-1 text-primary">
            {number_format(calculatedPrice, 2, ",", ".") +
              " " +
              product.currency}
          </div>
        </div>
        <div className="col-6">
          <div>
            <small>{t("products.endPrice")}</small>
          </div>
          <div className="fs-1 text-primary">
            {number_format(calculatedPriceEU, 2, ",", ".") +
              " " +
              product.currency}
          </div>
        </div>
      </div>

      <button
        onClick={() => onSelect(configuratedItem)}
        className="btn btn-primary w-100"
        disabled={!canOrder}
      >
        {t("opportunities.addToOpportunity")}
      </button>
      {!canOrder && (
        <div className="alert alert-info mt-5">
          {t("products.missingRequired")}
        </div>
      )}
    </form>
  );
}
